import React from 'react';
import { ClipboardCheckIcon, GaugeIcon, WavesIcon, PencilIcon, AnchorIcon, FlagIcon } from 'lucide-react';
const steps = [{
  label: '1 · Prepare',
  body: 'Screening, intention and consent — the Green-Amber-Red Screen and the Consent Ladder, before anyone lies down.',
  Icon: ClipboardCheckIcon
}, {
  label: '2 · Activate',
  body: 'Teach and connect the breath. The Pace Dial — Gentle, Steady or Full — sets the depth for this breather, today.',
  Icon: GaugeIcon
}, {
  label: '3 · Release',
  body: 'Ready-to-say lines for whatever arises: tears, strong energy, laughter, stillness, even “nothing happened.”',
  Icon: WavesIcon
}, {
  label: '4 · Integrate',
  body: 'Landing practices in session and a 7-Day Thread of small home practices, so the session settles.',
  Icon: PencilIcon
}, {
  label: '5 · Ground',
  body: 'Closing, the aftercare briefing and a take-home sheet, so nobody leaves unsteady.',
  Icon: AnchorIcon
}, {
  label: 'On every card',
  body: 'A safety flag: when not to breathe today, when to stop, when to refer.',
  Icon: FlagIcon
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-b border-sand-dark bg-cream" data-id="element-199" data-mp="1jsr7arellq21">
      <div className="mx-auto max-w-5xl px-5 py-16 text-center sm:py-20" data-id="element-200" data-mp="1orauev4xh7vz">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-201" data-mp="s2laz0dnk77w">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-202" data-mp="w4q663jr1bwn">
          The Breath Arc Method
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-ink-soft sm:text-lg" data-id="element-203" data-mp="1624grmizr6h1">
          A session can’t be read off a page — and it shouldn’t be. What you
          can prepare is the arc. Every Breath Card is built on the same five
          phases you already recognize from your training, so whether it’s a
          1:1, a circle, a workshop or a retreat, you combine ready modules
          instead of writing from zero.
        </p>

        <ol className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-204" data-mp="1mvvpa2f1o2qd">
          {steps.map(({
          label,
          body,
          Icon
        }, i) => <li key={label} className={`flex items-start gap-3 rounded-xl border px-4 py-3.5 ${i === steps.length - 1 ? 'border-terra/30 bg-terra/[0.06]' : 'border-sand-dark bg-white'}`} data-id="element-205" data-mp="1wrfj8ja1srch" data-mpi={i}>
              <span className={`mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full ${i === steps.length - 1 ? 'bg-terra/15 text-terra-deep' : 'bg-sage/10 text-sage'}`} data-id="element-206" data-mp="1isplr2jbgpnl">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="ldbpne7dh57y" />
              </span>
              <span data-id="element-208" data-mp="2x05ib2eshsu2">
                <span className="block text-[11px] font-bold uppercase tracking-widest text-sage" data-id="element-209" data-mp="2wznb5aql9u7d">
                  {label}
                </span>
                <span className="mt-1 block text-sm text-ink" data-id="element-210" data-mp="31s6pi9x3otd8">{body}</span>
              </span>
            </li>)}
        </ol>
      </div>
    </section>;
}